export const getUserLabel = (user) => {
  return user.username || user.common_name || user.full_name
}
